<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-envelope"></i>Mail Logs
        </div>
        <div class="card-body">
          <div class="form-group">
            <textarea class="form-control log" readonly id="exampleFormControlTextarea1" rows="30">{{toolsLog}}</textarea>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>


<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'Mail Logs',
  computed: mapGetters({
    toolsLog: 'ToolsLog'
  }),
  mounted () {
    this.ClearLog()
    this.emit('getMaillog')
  },
  methods: {
    ...mapActions([
      'ClearLog'
    ])
  }
}
</script>
